import React from 'react';
import { stickerLoadingWithCrop } from "../index";
import { ApiSelect, TextType } from "@baseTypes/baseType";
import { PhaseState } from "../../../../store/reducers/dashboard/phases/types";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../store";
import { identity } from "fp-ts/es6/function";
import { useTypedSelector } from "@hooks/useTypedSelector";
import Sticker from "@elements/sticker/Sticker";
import { isEmpty } from "lodash";
import Empty from "@pages/dashboard/phases/phasesWithArea/empty";
import st from "../common.module.scss";
import ChartHeader from "@elements/chart/ChartHeader";
import Tx from "@baseTypes/naming";
import { formatNumber2d } from "@utils/format/number";
import FlexLine from "@elements/flexLine/FlexLine";
import PhasesWithAreaChart from "@pages/dashboard/phases/phasesWithArea/chart";

const phaseSelector: ApiSelect<PhaseState> =
	createSelector((state: RootState) => state.phases, identity<PhaseState>);

type PhasesWithAreaProps = {
	phasesChartApi: undefined | Highcharts.Chart
}

const PhasesWithArea = (props: PhasesWithAreaProps) => {
	const { phasesChartApi } = props;
	const { data = [] } = useTypedSelector(phaseSelector);
	const total = data.reduce((acc, i) => acc + (i.sum || 0), 0);
	const { selected } = useTypedSelector(state => state.cropSelector);

	const renderBody = () => {
		return (
			<div className={st['content']}>
				<FlexLine textType={TextType.Header} className={st.header}>
					<ChartHeader>{Tx.StateCrops}</ChartHeader>
					<div className={st.total_label}>{formatNumber2d(total)} Га</div>
				</FlexLine>
				<PhasesWithAreaChart elements={data} chartApi={phasesChartApi} />
			</div>
		)
	}

	return (
		<Sticker>
			{total && selected && !isEmpty(selected) ? renderBody() : <Empty/>}
		</Sticker>
	)
}

export default stickerLoadingWithCrop(
	phaseSelector,
	actions => actions.fetchPhases
)(PhasesWithArea);